import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 67,
	height: 67,
	viewBox: "0 0 67 67",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_37965_7475)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M58.0869 31.0938C58.0869 43.8481 47.7475 54.1875 34.9932 54.1875C22.2388 54.1875 11.8994 43.8481 11.8994 31.0938C11.8994 18.3394 22.2388 8 34.9932 8C47.7475 8 58.0869 18.3394 58.0869 31.0938Z",
				fill: "url(#paint0_linear_37965_7475)"
			})
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -10.7666,
			y: 4.56128,
			width: 70.7783,
			height: 70.7786,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(7px)",
					clipPath: "url(#bgblur_0_37965_7475_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_ii_37965_7475)",
			"data-figma-bg-blur-radius": 14,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M46.012 39.9506C46.012 51.7636 36.4357 61.3399 24.6227 61.3399C12.8097 61.3399 3.2334 51.7636 3.2334 39.9506C3.2334 28.1376 12.8097 18.5613 24.6227 18.5613C36.4357 18.5613 46.012 28.1376 46.012 39.9506Z",
				fill: "#F15B50",
				fillOpacity: .5
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9661 30.1451C33.4982 29.6159 34.3426 29.6352 34.8515 30.1884C35.36 30.7419 35.3417 31.6203 34.8098 32.1496L26.5507 40.3598L34.8085 48.5714C35.3406 49.1007 35.3603 49.9789 34.8515 50.5325C34.3427 51.086 33.4984 51.1049 32.9661 50.5759L24.6223 42.2789L16.2786 50.5759C15.7464 51.1051 14.902 51.0859 14.3932 50.5325C13.8843 49.9789 13.9039 49.1007 14.4361 48.5714L22.6926 40.3598L14.4348 32.1496C13.9029 31.6202 13.8844 30.7419 14.3932 30.1884C14.9021 29.6352 15.7464 29.6159 16.2786 30.1451L24.6223 38.442L32.9661 30.1451Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_37965_7475",
				x: 3.89941,
				y: 0,
				width: 62.1875,
				height: 62.1875,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 4,
						result: "effect1_foregroundBlur_37965_7475"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ii_37965_7475",
				x: -10.7666,
				y: 4.56128,
				width: 70.7783,
				height: 70.7786,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_37965_7475"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 4
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_37965_7475",
						result: "effect2_innerShadow_37965_7475"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_37965_7475_clip_path",
				transform: "translate(10.7666 -4.56128)",
				children: /* @__PURE__ */ _jsx("path", { d: "M46.012 39.9506C46.012 51.7636 36.4357 61.3399 24.6227 61.3399C12.8097 61.3399 3.2334 51.7636 3.2334 39.9506C3.2334 28.1376 12.8097 18.5613 24.6227 18.5613C36.4357 18.5613 46.012 28.1376 46.012 39.9506Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_37965_7475",
				x1: 15.349,
				y1: 15.385,
				x2: 58.0869,
				y2: 54.1875,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#ED4245" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D6313B"
				})]
			})
		] })
	]
});
export default SvgIconError;
